/* =============================================================================
 * M.M.LaFleur — PDP accordions (Details / Features / Fit / Material & Care).
 *
 * SYMPTOM: on a hard load the accordions open and close normally. Arrive at
 * the same product by clicking a colour swatch, a search result or a category
 * link and they go dead — the row takes focus, so the click is landing, but
 * nothing expands.
 *
 * DIAGNOSIS: the giveaway is what happens to the row that was already open.
 * Clicking Fit closes Details AND leaves Fit shut. That is this handler firing
 * twice in one click: the first pass closes the siblings and opens Fit, the
 * second pass sees Fit already open and closes it again, skipping the sibling
 * sweep. A toggle run an even number of times lands back where it started.
 *
 * WHY TWICE, AND WHY stopImmediatePropagation
 * -------------------------------------------
 * Platter re-injects the footer's scripts around a Barba container swap, so
 * after the first soft navigation this file is executing a second time and a
 * second identical capture listener is bound to document.
 *
 * The first version of this file called stopPropagation(), which was not
 * enough. stopPropagation stops the event reaching other NODES; it does not
 * stop other listeners bound to the SAME node in the SAME phase. Both copies
 * of this listener sit on document, both on capture — so the second one ran
 * regardless. stopImmediatePropagation is what actually halts the remaining
 * listeners on this node, and it is why mm-sizeguide.js never had this
 * problem.
 *
 * The load guard below then stops the duplicate registration happening at all.
 * Both are kept: the guard is the clean fix, and the immediate stop means a
 * listener bound by anything else — now or later — still cannot double-handle
 * the click.
 *
 * State is SET from the row's own aria-expanded rather than toggled, so the
 * outcome does not depend on how many times the event is delivered.
 *
 * Panels are found through the row's .mm-acc-row rather than
 * nextElementSibling, so the markup can gain a wrapper later without silently
 * breaking this again.
 * ========================================================================== */

(function () {
  "use strict";

  if (window.__mmAccordionBound) return;
  window.__mmAccordionBound = true;

  document.addEventListener(
    "click",
    function (event) {
      var target = event.target;
      if (!target || !target.closest) return;

      var head = target.closest(".mm-acc-head");
      if (!head) return;

      var row = head.closest(".mm-acc-row");
      var panel = row ? row.querySelector(".mm-acc-body") : head.nextElementSibling;
      if (!panel) return;

      event.preventDefault();
      event.stopImmediatePropagation();

      var isOpen = head.getAttribute("aria-expanded") === "true";
      var next = isOpen ? "false" : "true";

      /* Close the siblings first, then open this one. Doing it in that order
         means a row that is already open is not reopened by its own sweep. */
      var group = head.closest(".mm-acc");
      if (!isOpen && group) {
        var heads = group.querySelectorAll(".mm-acc-head");
        for (var i = 0; i < heads.length; i++) {
          if (heads[i] === head) continue;
          heads[i].setAttribute("aria-expanded", "false");
          var otherRow = heads[i].closest(".mm-acc-row");
          var otherPanel = otherRow
            ? otherRow.querySelector(".mm-acc-body")
            : heads[i].nextElementSibling;
          if (otherPanel) otherPanel.setAttribute("data-open", "false");
        }
      }

      head.setAttribute("aria-expanded", next);
      panel.setAttribute("data-open", next);
    },
    true
  );
}());
